import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";

import List from 'views/TradingAccountsReport/List'



class TradingAccountsReport extends React.Component {
  render() {

    return (
          <Switch>
            <Route component={List}/>
          </Switch>
    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(TradingAccountsReport);



// WEBPACK FOOTER //
// ./src/views/TradingAccountsReport/TradingAccountsReport.jsx